import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isWebUri } from 'valid-url';
import { Form, Row, Col, Button, Spinner } from 'react-bootstrap';
import { Cache } from 'aws-amplify';
import DatePicker from 'react-datepicker';
import {
  handleFieldChange,
  upsertProject,
  getProject,
  fetchProjects,
  PENDING
} from '../../store/actions/projects/projectsActions';
import {
  addAttachment,
  setProjectAttachments,
  removeAttachment,
  resetNumAttachments,
  handleAttachmentValues
} from '../../store/actions/projects/projectAttachments';
import { fetchDepartments } from '../../store/actions/departments/departmentActions';
import {
  fetchProjectManagers,
  fetchUsers,
  fetchProjectSponsors,
  MANAGER, PORTAL_ADMIN, PROJECT_ADMIN
} from '../../store/actions/users/usersActions';
import { fetchPlatforms } from '../../store/actions/platforms/platformActions';
import { fetchClients } from '../../store/actions/clients/clientsActions';
import { toggleShowAlert, ERROR_ALERT, setWizardHasError } from '../../store/actions/commonActions';
import { toMonetaryFormat } from '../../common/Utilities';

import AttachmentField from './AttachmentField';

import SelectUserField from '../../common/SelectUserField';

import Select from 'react-select';

import "react-datepicker/dist/react-datepicker.css";
import PageTitle from '../../common/PageTitle';
import DepartmentField from '../../common/DepartmentField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

class ProjectForm extends Component {

  constructor(props) {
    super(props);
    this.action = '';
    this.defaultRole = {};
    this.submitButtonText = "Create";
    this.projectId = '';
    this.disableSubmit = true;
  }

  componentDidMount() {

    const roleId = Cache.getItem('roleId');

    if (roleId === MANAGER || roleId === PORTAL_ADMIN || roleId === PROJECT_ADMIN) {
      const pathname = this.props.location.pathname;
      if (pathname === '/projects/update') {
        this.action = 'UPDATE_PROJECT';
      }
      else {
        this.action = 'CREATE_PROJECT';
      }
    }
    else {
      this.props.history.push('/dashboard');
    }

    if (this.action === "UPDATE_PROJECT") {
      const urlParams = new URLSearchParams(this.props.location.search);
      const projectId = urlParams.get('id');
      this.props.getProject(projectId);
      this.submitButtonText = 'Send to Approvers';
    }
    else {
      this.props.resetNumAttachments();
    }

    this.props.fetchProjects({ is_disabled: 0 });
    this.props.fetchUsers();
    this.props.fetchClients();
    this.props.fetchProjectManagers();
    this.props.fetchDepartments();
    this.props.fetchProjectSponsors();
    this.props.fetchPlatforms();
  }

  componentWillUnmount() {
    Cache.removeItem('projectName');
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const submitButton = document.querySelector("button[type='submit']");
    submitButton.disabled = true;
    const origButtonText = this.submitButtonText;
    let projectAttachments = [];

    let attachmentNames = Array.from(document.querySelectorAll('.attachment_name'))
      .map(el => {
        return el.value;
      });
    let attachmentLinks = Array.from(document.querySelectorAll('.attachment_link'))
      .map(el => {
        return el.value;
      });


    let hasInvalidURL = false;

    attachmentNames.forEach((attachmentName, i) => {
      if (attachmentName && attachmentLinks[i]) {
        if (isWebUri(attachmentLinks[i])) {
          projectAttachments.push({
            attachment_name: attachmentName,
            attachment_link: attachmentLinks[i]
          })
        }
        else {
          hasInvalidURL = true;
        }
      }
    })

    if (!hasInvalidURL) {
      this.submitButtonText = <Spinner as="span" animation="border" size="sm" />;

      this.props.setProjectAttachments(projectAttachments, () => {
        this.props.upsertProject(this.action, () => {
          if (this.action === 'UPDATE_PROJECT') {
            this.props.history.push('/projects/view?id=' + this.projectId);
            this.props.getProject(this.projectId);
            this.submitButtonText = "Sent!";
            window.scrollTo(0, 0);
          }
          else {
            this.submitButtonText = "Created!";
            this.props.history.push('/projects');
          }

          setTimeout(() => {
            this.submitButtonText = origButtonText;
          }, 2000);
        }, false, true);
      })
    }
    else {
      submitButton.disabled = false;
      this.props.toggleShowAlert(true, ERROR_ALERT, 'The link in attachments is invalid. It should be a valid URL.');
    }
  }

  getClients = () => {
    const clients = this.props.clients.clients;
    const clientsList = clients.length > 0 && (
      clients.map((client, key) => {
        return (
          <option key={key} value={client.id}>
            {client.client_name}
          </option>
        )
      })
    )

    return clientsList;
  }

  getPMs = () => {
    const projectManagers = this.props.users.projectManagers;
    const pmList = projectManagers.length > 0 && (
      projectManagers.map((pm, key) => {
        return (
          <option key={key} value={pm.id}>
            {pm.first_name} {pm.last_name}
          </option>
        )
      })
    )

    return pmList;
  }

  displayFormTitle = () => {
    let formTitle = 'Create Project';
    if (this.action === 'UPDATE_PROJECT') {
      formTitle = 'Update Project';
    }

    return formTitle;
  }

  addTeamMembersField = () => {
    if (this.action === 'UPDATE_PROJECT') {
      return '';
    }

    const users = this.props.users.users;

    const onChangeCallback = (values) => {
      let arrTeamMembers = [];
      if (values) {
        values.forEach(option => {
          arrTeamMembers.push(option.value);
        });
      }
      this.disableSubmit = false;
      this.props.handleFieldChange(null, {
        team_members: arrTeamMembers
      });
    }

    return (
      <Row>
        <Col xs={4} sm={4} md={4} lg={4} xl={4}>
          <Form.Group controlId="team_members">
            <Form.Label>Team Members</Form.Label>
            <SelectUserField
              fieldName="team_members"
              users={users}
              onChangeCallback={onChangeCallback} />
          </Form.Group>
        </Col>
      </Row>
    )
  }

  projectManagerFields = (originalRevenue, projectRevenue, budgetedHours, fullyLoaded) => {
    const role = Cache.getItem('roleId');
    originalRevenue = parseFloat(originalRevenue);
    if (role === MANAGER || ((role === PORTAL_ADMIN || role === PROJECT_ADMIN))) {
      return (
        <>
          {this.action === 'CREATE_PROJECT' && <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <Form.Group controlId="total_contract_value">
                <Form.Label>Project Revenue <span className="required-field"> * </span></Form.Label>
                <Form.Control
                  size="sm"
                  defaultValue={originalRevenue > 0 ? toMonetaryFormat(originalRevenue) : ''}
                  type="text"
                  step="0.01"
                  autoComplete="off"
                  onFocus={() => {
                    let originalRevenue = document.getElementById('total_contract_value');
                    originalRevenue.value = originalRevenue.value.replace(/,/g, '');
                  }}
                  onBlur={(e) => {
                    let originalRevenue = document.getElementById('total_contract_value');
                    let projectRevenue = e.target.value;
                    if (projectRevenue) {
                      if (isNaN(projectRevenue)) {
                        this.props.toggleShowAlert(true, ERROR_ALERT, 'Invalid Project Revenue Value.');
                        originalRevenue.value = "";
                      } else if (fullyLoaded && projectRevenue <= 0) {
                        this.props.toggleShowAlert(true, ERROR_ALERT, 'Project Revenue Value should be greater than zero.');
                        originalRevenue.value = "";
                      } else {
                        this.disableSubmit = false;
                        this.props.handleFieldChange(e);
                        this.props.handleFieldChange(null, {
                          project_revenue: projectRevenue
                        });
                        const originalRevenueValue = toMonetaryFormat(parseFloat(originalRevenue.value));
                        originalRevenue.value = originalRevenueValue;
                      }
                    }
                  }}
                  required 
                />
              </Form.Group>

            </Col>
          </Row>}
          {this.action === 'UPDATE_PROJECT' && <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <Form.Group controlId="project_revenue">
                <Form.Label>Project Revenue</Form.Label>
                <Form.Control
                  size="sm"
                  defaultValue={projectRevenue > 0 ? toMonetaryFormat(parseFloat(projectRevenue)) : ''}
                  type="text"
                  step="0.01"
                  onFocus={() => {
                    let projectRevenue = document.getElementById('project_revenue');
                    projectRevenue.value = projectRevenue.value.replace(/,/g, '');
                  }}
                  onBlur={(e) => {
                    let projectRevenue = document.getElementById('project_revenue');

                    if (isNaN(e.target.value)) {
                      this.props.toggleShowAlert(true, ERROR_ALERT, 'Invalid Project Revenue Value.')
                      projectRevenue.value = "";
                    }
                    else if (fullyLoaded && e.target.value <= 0) {
                      this.props.toggleShowAlert(true, ERROR_ALERT, 'Project Revenue Value should be greater than zero.')
                      projectRevenue.value = "";
                    }
                    else {
                      this.disableSubmit = false;
                      this.props.handleFieldChange(e);

                      const revenueValue = toMonetaryFormat(parseFloat(projectRevenue.value));
                      projectRevenue.value = revenueValue;
                    }
                  }} 
                  required
                  />
              </Form.Group>
            </Col>
          </Row>}
          {/* <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <Form.Group controlId="budgeted_hours">
                <Form.Label>Budgeted Hours</Form.Label>
                <Form.Control size="sm" defaultValue={budgetedHours} type="text" onChange={(e) => {
                        this.disableSubmit = false;
                        this.props.handleFieldChange(e);
                      }} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <Form.Group controlId="mandays">
                <Form.Label>Mandays</Form.Label>
                <Form.Control size="sm" disabled="disabled" value={budgetedHours/8} type="text"  />
              </Form.Group>
            </Col>
          </Row> */}
        </>
      )
    } else {
      return '';
    }
  }

  displayPMField = (projectManager) => {
    const projectManagers = this.props.users.projectManagers;

    const onChangeCallback = (value) => {
      this.disableSubmit = false;
      this.props.handleFieldChange(null, {
        project_manager: value.value
      });
    }

    return (
      <Row>
        <Col xs={4} sm={4} md={4} lg={4} xl={4}>
          <Form.Group controlId="project_manager">
            <Form.Label>MS Manager <span className='required-field'> * </span></Form.Label>
            <SelectUserField
              users={projectManagers}
              defaultValue={projectManager}
              multiple={false}
              fieldName="project_manager"
              onChangeCallback={onChangeCallback}
            />
          </Form.Group>
        </Col>
      </Row>
    )
  }

  displayProjSponsorField = (projectSponsor) => {
    let projectSponsors = this.props.users.projectSponsors;

    if (!projectSponsors) {
      projectSponsors = [];
    }

    const onChangeCallback = (value) => {
      this.disableSubmit = false;
      this.props.handleFieldChange(null, {
        project_sponsor: value.value
      });
    }

    return (
      <Row>
        <Col xs={4} sm={4} md={4} lg={4} xl={4}>
          <Form.Group controlId="project_sponsor">
            <Form.Label>Project Sponsor <span className='required-field'> * </span></Form.Label>
            <SelectUserField
              users={projectSponsors}
              defaultValue={projectSponsor}
              multiple={false}
              fieldName="project_sponsor"
              onChangeCallback={onChangeCallback}
            />
          </Form.Group>
        </Col>
      </Row>
    )
  }

  displayClientField = (client) => {
    const clients = this.props.clients.clients;
    let defaultValueIndex = null;
    let clientOptions = [];
    let currentValue = '';

    const onChangeCallback = (value) => {
      this.disableSubmit = false;
      this.props.handleFieldChange(null, {
        client_id: value.value,
        client_name: value.label
      });
    }

    clientOptions = clients.length && clients.map(client => {
      return {
        label: client.client_name,
        value: client.id
      }
    })

    //get default value
    if (client) {
      if (typeof (clientOptions) === 'object') {
        clientOptions.forEach((clientOpt, index) => {
          if (clientOpt.value === client) {
            defaultValueIndex = index;
          }
        })

        if (clientOptions.length > 0) {
          currentValue = clientOptions[defaultValueIndex]
        }
      }
    }

    if (clientOptions.length > 0) {
      return (
        <Row>
          <Col xs={4} sm={4} md={4} lg={4} xl={4}>
            <Form.Group controlId="client_id">
              <Form.Label>Client <span className='required-field'> * </span></Form.Label>
              <Select
                value={currentValue}
                isSearchable={true}
                name="client"
                isMulti={false}
                options={clientOptions}
                onChange={(value) => onChangeCallback(value)}
              />
            </Form.Group>
          </Col>
        </Row>
      )
    }
    return '';
  }

  filterProjectDetails = (projects) => {
    return projects.map(project => {
      return {
        id: project.id,
        name: project.project_name
      }
    })
  }

  displayParentProjectField = (projectId, parentProject) => {
    let projects = this.filterProjectDetails(this.props.projects.projects);

    let defaultValueIndex = null;
    let projectOptions = [];
    let currentValue = '';

    //don't choose current project as parent
    if (this.action === 'UPDATE_PROJECT') {
      if (projects) {
        projects = projects.length ? projects.filter(data => {
          if (+data.id !== +projectId) {
            return data;
          }
          return null;
        }).map(project => {
          return project;
        }) : []
      }
    }

    const onChangeCallback = (value) => {
      this.disableSubmit = false;
      this.props.handleFieldChange(null, {
        parent_project: value.value
      });
    }

    projectOptions = projects.length ? projects.map(project => {
      return {
        label: project.name,
        value: project.id
      }
    }) : []

    if (typeof (projectOptions) === "object") {
      projectOptions.unshift({
        key: 0,
        label: "--NONE--",
        value: 0
      })
    }
    //get default value
    if (parentProject || Number.isInteger(parentProject)) { //zero is acceptable
      if (typeof (projectOptions) === 'object') {
        projectOptions.forEach((projectOpt, index) => {
          if (projectOpt.value === parentProject) {
            defaultValueIndex = index;
          }
        })

        if (projectOptions.length > 0) {
          currentValue = projectOptions[defaultValueIndex]
        }
      }
    }

    return (
      <Row>
        <Col xs={4} sm={4} md={4} lg={4} xl={4}>
          <Form.Group controlId="client_id">
            <Form.Label>Parent Project</Form.Label>
            <Select
              value={currentValue}
              isSearchable={true}
              name="client"
              isMulti={false}
              options={projectOptions}
              onChange={(value) => onChangeCallback(value)}
            />
          </Form.Group>
        </Col>
      </Row>
    )
  }

  displayDepartmentField = (department) => {
    return (
      <Row>
        <Col xs={4} sm={4} md={4} lg={4} xl={4}>
          <Form.Group controlId="department">
            <Form.Label>Department <span className='required-field'> * </span></Form.Label>
            <DepartmentField department={department} onChangeCallback={(item) => {
              this.disableSubmit = false;
              this.props.handleFieldChange(null, {
                department_id: item.value
              });
            }} />
          </Form.Group>
        </Col>
      </Row>
    )
  }

  displayPlatformField = (defaultPlatforms) => {

    const onChangeCallback = (values) => {
      let arrPlatforms = [];
      if (values) {
        values.forEach(option => {
          arrPlatforms.push(option.value);
        });
      }
      this.disableSubmit = false;
      this.props.handleFieldChange(null, {
        platform: arrPlatforms
      });
    }

    const platforms = this.props.platforms.platforms;

    let platformOptions = [];
    platformOptions = platforms && platforms.length ? platforms.map(platform => {
      return {
        label: platform.platform_name,
        value: platform.id
      }
    }) : []

    let defaultValues = [];

    if (defaultPlatforms) {
      let arrPlatforms = [];
      defaultPlatforms.forEach(platform => {
        let platformId = '';
        if (typeof (platform.id) !== "undefined") {
          platformId = platform.id;
        }
        else {
          platformId = platform;
        }
        arrPlatforms.push(platformId);
      })

      if (typeof (platformOptions) === 'object') {
        platformOptions.forEach((platformOpt, index) => {
          if (arrPlatforms.includes(platformOpt.value)) {
            defaultValues.push(platformOptions[index]);
          }
        })
      }

    }

    return (
      <Row>
        <Col xs={4} sm={4} md={4} lg={4} xl={4}>
          <Form.Group controlId="client_id">
            <Form.Label>Group <span className='required-field'> * </span></Form.Label>
            <Select
              isSearchable={true}
              value={defaultValues}
              name="department"
              isMulti={true}
              options={platformOptions}
              onChange={(value) => onChangeCallback(value)}
            />
          </Form.Group>
        </Col>
      </Row>
    )
  }

  displayIsFullyLoadedRadio = (fullyLoaded) => {

    let isCheckedUnloaded = false;
    let isCheckedFullyLoaded = false;

    if (Number.isInteger(fullyLoaded)) {
      if (fullyLoaded) {
        isCheckedUnloaded = false;
        isCheckedFullyLoaded = true;
      }
      else {
        isCheckedUnloaded = true;
        isCheckedFullyLoaded = false;
      }
    }

    return (
      <>
        <Row className="mb-3">
          <Col>Costing Type <span className='required-field'> * </span></Col>
        </Row>
        <Row className="mb-3" onChange={(e) => {
          this.disableSubmit = false;
          let fully_loaded;

          if (e.target.id === "fully-loaded") {
            fully_loaded = 1;
          }
          else {
            fully_loaded = 0;
          }

          this.props.handleFieldChange(null, {
            fully_loaded
          })

        }}>
          <Col xs={4} sm={4} md={4} lg={4} xl={4}>
            <Form.Check
              inline
              label="Fully Loaded"
              checked={isCheckedFullyLoaded}
              type="radio"
              id="fully-loaded"
              name="costing-type" 
              required/>
            <Form.Check
              inline
              label="Unloaded"
              checked={isCheckedUnloaded}
              type="radio"
              id="unloaded"
              name="costing-type" 
              required/>
          </Col>
        </Row>
      </>
    )
  }

  displayAttachmentField = () => {

    let attachmentField = [];
    let numAttachments = this.props.projects.numAttachments;
    let project = this.props.projects.project;

    for (let i = 1; i <= numAttachments; i++) {
      let attachment = {}
      let attachmentId = '';
      let isNew = false;
      let projectAttachments = project.project_attachments;

      if (typeof (projectAttachments) !== "undefined") {
        //get the current attachments
        if (projectAttachments.length <= numAttachments) {
          if (projectAttachments.length) {
            attachment = projectAttachments[i - 1];
          }
        }

        if (typeof (attachment) !== "undefined") {
          attachmentId = attachment.id;
        }
      }
      //use index as attachmentId if a new one
      if (!attachmentId) {
        attachmentId = i;
        isNew = true;
      }

      attachmentField.push(
        <AttachmentField key={i} attachmentId={attachmentId} isNew={isNew} action={this.action} attachment={attachment}
          onRemoveAttachment={(attachmentId) => {
            this.disableSubmit = false;
            if (this.action === 'UPDATE_PROJECT') {
              this.props.removeAttachment(attachmentId);
            }
            else {
              document.getElementById('attachment-id-' + attachmentId).remove();
            }
          }}
          onChange={(e, attachmentId, attachmentField) => {
            //apply the change directly to the state if for current 
            if (!isNew) {
              this.props.handleAttachmentValues(e.target.value, attachmentId, attachmentField)
            }
            this.disableSubmit = false;
          }} />
      )
    }
    return (
      <>
        <Row>
          <Col>Attachments</Col>
        </Row>
        {attachmentField}
        <Row className="mt-3 mb-5">
          <Col xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="align-right">
              <Button
                size="sm"
                onClick={() => {
                  this.props.addAttachment();
                  this.disableSubmit = false;
                }}>
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </div>
          </Col>
        </Row>
      </>
    )
  }

  render() {
    this.defaultRole = this.props.users.defaultUserRole;

    let projectName = '';
    let projectCode = '';
    let client = '';
    let parentProject = '';
    let startDate = '';
    let endDate = '';
    let projectManager = 0;
    let projectSponsor = 0;
    let originalRevenue = '';
    let budgetedHours = '';
    let platform = [];
    let department = '';
    let fullyLoaded = '';
    let projectRevenue = '';

    const project = this.props.projects.project;

    if (Object.keys(project).length > 0) {

      if (project.is_disabled) {
        this.props.toggleShowAlert(true, ERROR_ALERT, 'You are not allowed to perform this action.');
        this.props.history.push('/projects/disabled');
      }

      this.projectId = project.id;
      projectName = project.project_name;
      projectCode = project.project_code;
      originalRevenue = project.total_contract_value;
      platform = project.platform;
      projectRevenue = project.project_revenue;

      if (typeof (project.project_manager) !== "undefined") {
        projectManager = project.project_manager;

        if (projectManager && typeof (projectManager.id) !== "undefined") {
          projectManager = projectManager.id;
        }
      }
      if (typeof (project.project_sponsor) !== "undefined") {
        projectSponsor = project.project_sponsor;

        if (projectSponsor && typeof (projectSponsor.id) !== "undefined") {
          projectSponsor = projectSponsor.id;
        }
      }

      if (typeof (project.department_id) !== "undefined") {
        department = project.department_id;
        if (department && typeof (department.id) !== "undefined") {
          department = department.id;
        }
      }

      if (typeof (project.start_date) !== "undefined") {
        startDate = new Date(project.start_date);
      }

      if (typeof (project.end_date) !== "undefined") {
        endDate = new Date(project.end_date);
      }

      if (typeof (project.client_id) !== "undefined") {
        client = project.client_id
      }

      if (typeof (project.parent_project) !== "undefined") {
        parentProject = project.parent_project;
        if (parentProject && typeof (parentProject.id) !== "undefined") {
          parentProject = parentProject.id;
        }
      }

      if (typeof (project.budgeted_hours) !== 'undefined') {
        budgetedHours = project.budgeted_hours;
      }

      if (typeof (project.fully_loaded) !== "undefined") {
        fullyLoaded = project.fully_loaded;
      }

      client = project.client_id || 0;
    }

    let disabled = false;

    const role = Cache.getItem('roleId');

    if (role !== PORTAL_ADMIN && role !== PROJECT_ADMIN && role !== MANAGER) {
      disabled = true;
    }

    if (project.status === PENDING) {
      this.disableSubmit = true;
    }

    return (
      <>
        {!this.props.isImported && <PageTitle pageName="Update Project" />}
        <Row className="t3-form">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Form onSubmit={this.handleSubmit}>
              <Row>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <Form.Group controlId="project_name">
                    <Form.Label>Project Name <span className='required-field'> * </span></Form.Label>
                    <Form.Control size="sm" defaultValue={projectName}
                      type="text"
                      disabled={disabled}
                      onChange={(e) => {
                        this.disableSubmit = false;
                        this.props.handleFieldChange(e);
                      }} />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <Form.Group controlId="project_code">
                    <Form.Label>Project Code <span className='required-field'> * </span></Form.Label>
                    <Form.Control size="sm" defaultValue={projectCode}
                      type="text"
                      disabled={disabled}
                      onChange={(e) => {
                        this.disableSubmit = false;
                        this.props.handleFieldChange(e);
                      }} />
                  </Form.Group>
                </Col>
              </Row>
              {this.displayParentProjectField(this.projectId, parentProject)}
              {this.displayClientField(client)}
              <Row>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <div>
                    <Form.Label>Start Date <span className='required-field'> * </span></Form.Label>
                  </div>
                  <div>
                    <div className="form-group project-datepicker">
                      <DatePicker
                        selected={startDate}
                        id="start_date"
                        autoComplete="off"
                        className="form-control form-control-sm"
                        onChange={(date) => {
                          var start_date = date;
                          this.disableSubmit = false;
                          this.props.handleFieldChange(null, {
                            start_date
                          })
                        }} />
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <div>
                    <Form.Label>End Date <span className='required-field'> * </span></Form.Label>
                  </div>
                  <div>
                    <div className="form-group project-datepicker">
                      <DatePicker
                        selected={endDate}
                        id="end_date"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        onChange={(date) => {
                          var end_date = date;
                          this.disableSubmit = false;
                          this.props.handleFieldChange(null, {
                            end_date
                          })
                        }} />
                    </div>
                  </div>
                </Col>
              </Row>
              {this.displayPMField(projectManager)}
              {/* {this.displayProjSponsorField(projectSponsor)} */}
              {this.displayDepartmentField(department)}
              {this.displayIsFullyLoadedRadio(fullyLoaded)}
              {this.displayPlatformField(platform)}
              {this.projectManagerFields(originalRevenue, projectRevenue, budgetedHours, fullyLoaded)}
              {this.displayAttachmentField()}
              {!this.props.inWizard && <Row>
                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                  <div className="align-right">
                    <Button variant="default" onClick={() => {
                      this.props.history.push('/projects/view?id=' + project.id);
                    }}>Cancel</Button>
                    <Button variant="primary" type="submit" disabled={this.disableSubmit}>
                      {this.submitButtonText}
                    </Button>
                  </div>
                </Col>
              </Row>}
            </Form>
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  clients: state.clients,
  users: state.users,
  projects: state.projects,
  departments: state.departments,
  platforms: state.platforms
})

const mapDispatchToProps = (dispatch) => {
  return {
    handleFieldChange: (...args) => dispatch(handleFieldChange(...args)),
    upsertProject: (...args) => dispatch(upsertProject(...args)),
    getProject: (...args) => dispatch(getProject(...args)),
    setWizardHasError: (...args) => dispatch(setWizardHasError(...args)),
    fetchProjectManagers: () => dispatch(fetchProjectManagers()),
    fetchProjectSponsors: () => dispatch(fetchProjectSponsors()),
    fetchClients: () => dispatch(fetchClients()),
    fetchUsers: () => dispatch(fetchUsers()),
    fetchDepartments: () => dispatch(fetchDepartments()),
    fetchPlatforms: (...args) => dispatch(fetchPlatforms(...args)),
    toggleShowAlert: (...args) => dispatch(toggleShowAlert(...args)),
    fetchProjects: (...args) => dispatch(fetchProjects(...args)),
    addAttachment: () => dispatch(addAttachment()),
    setProjectAttachments: (...args) => dispatch(setProjectAttachments(...args)),
    removeAttachment: (...args) => dispatch(removeAttachment(...args)),
    resetNumAttachments: () => dispatch(resetNumAttachments()),
    handleAttachmentValues: (...args) => dispatch(handleAttachmentValues(...args))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProjectForm))
